/**
 * Imports jQuery.
 *
 * @see http://api.jquery.com/
 *
 * @since 1.0.0
 */
import $ from 'jquery';

/* eslint-disable */
/**
 * Ajax sorting for Event archives.
 *
 * @since 1.0.0
 */
$( document ).on(
	"change",
	"#audience-select",
	function () {
		const eventURL  = $( this ).val();
		window.location = eventURL;
	}
);
$( document ).on(
	"keyup input propertychange paste change",
	"#resource-search",
	function () {
		const searchVal = $( this ).val();
		var parsedUrl   = window.location.href;
		setTimeout(
			function () {
				if (searchVal === '' || searchVal === null) {
					parsedUrl       = parsedUrl.split( "?" )[0];
					window.location = parsedUrl;
				}
			},
			500
		);
	}
);

$( document ).on(
	"change",
	"#resource-select",
	function () {
		const eventURL  = $( this ).val();
		window.location = eventURL;
	}
);
